<script lang="ts" context="module">
  export type StartGameCallback = (settings: GameInitSettings) => void;
</script>

<script type="ts">
  import { data } from "./data";
import type { GameInitSettings } from "./Game.svelte";
  export let startGameCallback: StartGameCallback;
  type CatKey = keyof typeof data;
  const options = Object.keys(data) as CatKey[];

  const optionChecked = options.reduce((acc, curr) => {
    acc[curr] = false;
    return acc;
  }, {} as {[key in CatKey]: boolean});

  let duration = 90;

  function handleSubmit(event: Event) {
    event.preventDefault();
    const checkedKeys  = options.filter(option => optionChecked[option]);
    const prompts = checkedKeys.flatMap(key => data[key as CatKey]);
    startGameCallback({
      prompts,
      duration
    });
  }
</script>

<h2>STRNRTN Create Game</h2>
<form on:submit={handleSubmit}> 
  <label class="duration">
    Duration {duration}s
    <input type="range" min="10" max="180" bind:value={duration} step="5">
  </label>
  <div class="categories">
    {#each options as option}
    <label>
      <input type="checkbox" value={option} bind:checked={optionChecked[option]}>
      {option}
    </label>
    {/each}
  </div>
  <button>Start Game</button>
</form>

<style>
  .categories label { 
    margin: auto;
    font-size: larger;
    text-align: left;
    width: 300px;
    grid-template-columns: auto 50px;
  }

  .duration {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }

  .duration input {
    margin: 0;
  }

  button {
    margin-top: 20px;
  }
</style>